
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component
export default class ConfirmDialog extends Vue {
    @Prop({ required: true }) trigger!: boolean
    @Prop({ required: false }) dataToConfirm: unknown

    @Watch('trigger')
    ondialogPropChange () {
        this.dialog = true
    }

    dialog = false
}
